import { v4 as uuidv4 } from "uuid";
import { callRouteType, ringingType, nodeClassification, defaultCallFlowConfiguration } from "../utils/VoiceUtils";

export const initialNodes = [
  { id: "1", type: "phone_number", position: { x: 118, y: -38 }, nodeId: uuidv4(), data: {}, classification: nodeClassification.HOLD },
  { id: "2", type: "business_hour", position: { x: 118, y: 199 }, nodeId: uuidv4(), classification: nodeClassification.BH },
  { id: "3", type: "open_node", position: { x: -29, y: 287 } },
  { id: "4", type: "close_node", position: { x: 325, y: 288 } },
  { id: "5", type: "welcome_message", position: { x: 118, y: 42 }, nodeId: uuidv4(), classification: nodeClassification.WELCOME },
  { id: "6", type: "call_recording", position: { x: 118, y: 123 }, nodeId: uuidv4(), classification: nodeClassification.RECORD },
  { id: "7", type: "hang_up", position: { x: 349, y: 444 } },
  {
    id: "8",
    type: "unavailable_out_of_business_hours",
    position: { x: 296, y: 362 },
    nodeId: uuidv4(),
    classification: nodeClassification.UNAVAILABLE_OUT_OF_BUSINESS_HOURS,
  },
  {
    id: "9",
    type: "call_route",
    position: { x: -60, y: 363 },
    nodeId: uuidv4(),
    classification: nodeClassification.CALL_ROUTE,
    data: {
      // routeType: callRouteType.DIRECT,
      teamId: null,
      ringingType: ringingType.SIMULTANEOUS,
      ringInterval: defaultCallFlowConfiguration.ringInterval,
      repeatCount: defaultCallFlowConfiguration.repeatCount,
      ivrConfig: [],
      readOutFormat: "Please press {ivrNumber} for {ivrName}",
    },
  },
];

export const commonNoAnswerActionNodes = [
  { id: "111", type: "no_answer", position: { x: -35, y: 594 }, nodeId: uuidv4() },
  {
    id: "112",
    type: "busy",
    position: { x: -198, y: 676 },
    nodeId: uuidv4(),
    classification: nodeClassification.BUSY,
  },
  {
    id: "113",
    type: "unavailable",
    position: { x: 66, y: 676 },
    nodeId: uuidv4(),
    classification: nodeClassification.UNAVAILABLE,
  },
  { id: "114", type: "hang_up", position: { x: 120, y: 753 }, nodeId: uuidv4() },
  { id: "115", type: "hang_up", position: { x: -145, y: 757 }, nodeId: uuidv4() },
];

export const nodeForDirectRoute = [
  { id: "24", type: "ring_team", position: { x: -60, y: 472 }, nodeId: uuidv4(), classification: nodeClassification.TEAMS, data:{} },
  { id: "111", type: "no_answer", position: { x: -35, y: 594 }, nodeId: uuidv4() },
  {
    id: "112",
    type: "busy",
    position: { x: -198, y: 676 },
    nodeId: uuidv4(),
    classification: nodeClassification.BUSY,
  },
  {
    id: "113",
    type: "unavailable",
    position: { x: 66, y: 676 },
    nodeId: uuidv4(),
    classification: nodeClassification.UNAVAILABLE,
  },
  { id: "114", type: "hang_up", position: { x: 120, y: 753 }, nodeId: uuidv4() },
  { id: "115", type: "hang_up", position: { x: -145, y: 757 }, nodeId: uuidv4() },
];

export const initialEdges = [
  { id: "e1-5", source: "1", target: "5", type: "CustomEdge" },
  { id: "e5-6", source: "5", target: "6", type: "CustomEdge" },
  { id: "e6-2", source: "6", target: "2", type: "CustomEdge" },
  { id: "e2-3", source: "2", target: "3", type: "CustomEdge" },
  { id: "e2-4", source: "2", target: "4", type: "CustomEdge" },
  { id: "e3-9", source: "3", target: "9", type: "CustomEdge" },
  { id: "e9-24", source: "9", target: "24", type: "CustomEdge" },
  { id: "e24-12", source: "24", target: "111", type: "CustomEdge" },
  { id: "e4-8", source: "4", target: "8", type: "CustomEdge" },
  { id: "e8-7", source: "8", target: "7", type: "CustomEdge" },
  { id: "e111-13", source: "111", target: "112", type: "CustomEdge" },
  { id: "e111-113", source: "111", target: "113", type: "CustomEdge" },
  { id: "e112-115", source: "112", target: "115", type: "CustomEdge" },
  { id: "e113-114", source: "113", target: "114", type: "CustomEdge" },
];
